import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-mise-en-avant-chip',
  templateUrl: './mise-en-avant-chip.component.html',
  styleUrls: ['./mise-en-avant-chip.component.scss'],
})
export class MiseEnAvantChipComponent implements OnInit {
  constructor() {}

  @HostBinding('class') get classe() {
    return 'chip-element';
  }

  ngOnInit() {}
}
